var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "In_progress-pana",
    "data-name": "In progress-pana",
    xmlns: "http://www.w3.org/2000/svg",
    width: 403.6,
    height: 286,
    viewBox: "0 0 403.6 286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2",
    transform: "translate(51.372 18.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14762",
    "data-name": "Path 14762",
    d: "M119.446,192.045s3.675-3.006,9.438,5.907a122.1,122.1,0,0,1,8.145,14.184s1.47,1.844,2.691.414,2.711-5.284,5.08-4.857,3.525,3.026,3.465,6.99.151,12.667.171,13.448.571,1.857,1.562,1.017,6.419-8.29,9.8-5.5,1.411,13.783,1.221,15.024.085,1.687.656,1.923,2.179-2.442,3.807-4.5,3.886-4.155,5.7-2.383,3.157,9.753-3.157,23.6l-3.347,6.222-7.082.328c-15.214-.217-21.856-4.844-22.683-7.22s2.035-3.531,4.594-4.128,5.651-.879,5.69-1.516-.269-1.09-1.444-1.437-11.985-3.282-13.055-7.528,7.981-5.966,9.189-6.5.44-1.5-.249-1.851-8.473-4.26-12.083-5.907-5.494-3.715-4.837-6.124,4.745-2.022,6.563-2.514.781-2.625.781-2.625a123.487,123.487,0,0,1-9.333-13.429c-5.605-9.031-1.195-11.1-1.195-11.1",
    transform: "translate(129.603 -109.247)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14763",
    "data-name": "Path 14763",
    d: "M169.451,269.143c-4.141-6.616-11.7-18.259-18.135-28.282s-12.254-19.106-16.409-25.7l-4.936-7.817-1.313-2.127-.354-.551c-.079-.125-.125-.184-.125-.184l.105.2c.085.131.2.322.335.558l1.313,2.146c1.135,1.864,2.8,4.548,4.877,7.876,4.142,6.622,9.937,15.713,16.376,25.742s14.013,21.659,18.187,28.223",
    transform: "translate(126.093 -113.688)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14764",
    "data-name": "Path 14764",
    d: "M165.067,224.49a2.535,2.535,0,0,0-.125.5c-.072.322-.158.788-.263,1.365-.2,1.155-.44,2.757-.656,4.535s-.427,3.334-.578,4.542c-.072.545-.138,1-.184,1.378a2.624,2.624,0,0,0-.053.505,1.773,1.773,0,0,0,.138-.492c.066-.322.151-.788.249-1.365.19-1.162.414-2.77.656-4.542s.453-3.328.61-4.542l.2-1.372A1.969,1.969,0,0,0,165.067,224.49Z",
    transform: "translate(107.475 -120.565)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14765",
    "data-name": "Path 14765",
    d: "M181.759,242.933c0-.059-3.282-.7-7.338-1.431s-7.364-1.273-7.371-1.214,3.282.7,7.331,1.431S181.745,242.992,181.759,242.933Z",
    transform: "translate(88.277 -125.992)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14766",
    "data-name": "Path 14766",
    d: "M164.122,267.093a2.443,2.443,0,0,0-.525,0l-1.4.151c-1.195.125-2.835.289-4.66.407s-3.472.171-4.667.2h-1.418a1.819,1.819,0,0,0-.518.039,3.017,3.017,0,0,0,.518.046h1.418c1.2,0,2.855,0,4.686-.131s3.472-.3,4.66-.466c.591-.085,1.07-.158,1.4-.223A2.851,2.851,0,0,0,164.122,267.093Z",
    transform: "translate(116.491 -135.201)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14767",
    "data-name": "Path 14767",
    d: "M148.512,249.92a2.526,2.526,0,0,0-.23.427l-.571,1.181c-.466,1-1.1,2.389-1.792,3.938s-1.313,2.947-1.733,3.938l-.5,1.208a1.87,1.87,0,0,0-.158.459,1.969,1.969,0,0,0,.236-.427l.564-1.181c.466-1,1.1-2.389,1.792-3.938s1.313-2.94,1.733-3.938c.2-.473.368-.88.5-1.208a1.871,1.871,0,0,0,.158-.459Z",
    transform: "translate(136.957 -129.304)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14768",
    "data-name": "Path 14768",
    d: "M133.264,268.23a3.232,3.232,0,0,0-.3.538l-.735,1.516c-.6,1.28-1.431,3.052-2.337,5.021s-1.7,3.754-2.277,5.054c-.269.617-.492,1.135-.656,1.542a3.159,3.159,0,0,0-.223.578,3.284,3.284,0,0,0,.3-.545l.735-1.51c.6-1.313,1.431-3.059,2.337-5.028s1.706-3.754,2.278-5.054l.656-1.536A3.636,3.636,0,0,0,133.264,268.23Z",
    transform: "translate(163.213 -135.597)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14769",
    "data-name": "Path 14769",
    d: "M153.307,289.343a4.23,4.23,0,0,0-.656,0l-1.792.125c-1.516.105-3.61.236-5.907.322s-4.411.112-5.907.118h-1.8a3.765,3.765,0,0,0-.656,0,4.6,4.6,0,0,0,.656.059c.42,0,1.037.046,1.8.059,1.516,0,3.616,0,5.907-.052s4.411-.249,5.907-.387l1.785-.2A4.162,4.162,0,0,0,153.307,289.343Z",
    transform: "translate(136.717 -142.848)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14770",
    "data-name": "Path 14770",
    d: "M41.818,218.171A18.693,18.693,0,0,0,42,221.407a23.405,23.405,0,0,0,2.947,8.683l.066-.118h-.138l.066.118,18.378,32.6.112.2.131-.2,19.428-31,.958-1.529.151-.236h-.282l.131.236a23.74,23.74,0,0,0,2.927-8.191,22.183,22.183,0,0,0,.3-4.26l-.118-2.107c-.105-.7-.21-1.385-.308-2.074a23.937,23.937,0,0,0-7.935-13.567,23.063,23.063,0,0,0-6.386-3.748l-.847-.315-.42-.158-.433-.118-1.713-.446a24.756,24.756,0,0,0-3.426-.413,23.362,23.362,0,0,0-3.328.059c-.545.046-1.076.164-1.608.236l-.788.131c-.256.053-.512.131-.768.2l-1.5.407-1.424.545c-.236.092-.473.171-.7.269l-.656.335-1.313.656a23.576,23.576,0,0,0-7.548,6.97,23.989,23.989,0,0,0-3.282,7.036,20.938,20.938,0,0,0-.578,2.783,14.716,14.716,0,0,0-.223,2.067,9.766,9.766,0,0,1-.046,1.28,1,1,0,0,0,0,.433v-.433c0-.282.039-.722.072-1.273a16.324,16.324,0,0,1,.249-2.061,22.058,22.058,0,0,1,.6-2.763,24.14,24.14,0,0,1,3.282-6.97,23.5,23.5,0,0,1,7.548-6.885l1.313-.656.656-.322c.223-.105.459-.177.7-.269l1.411-.538,1.49-.394c.249-.066.5-.144.755-.2l.781-.125c.525-.072,1.05-.184,1.588-.23a22.971,22.971,0,0,1,3.282-.046,24.2,24.2,0,0,1,3.387.414l1.693.446.427.118.413.151.834.315a22.742,22.742,0,0,1,6.334,3.7A23.628,23.628,0,0,1,86.456,213.6c.1.656.2,1.359.3,2.041s.079,1.385.112,2.087a22.2,22.2,0,0,1-.289,4.207,23.55,23.55,0,0,1-2.888,8.08l-.138.236h.269l-.131-.236c-.3.486-.656,1-.952,1.529L63.326,262.559h.243c-7.732-13.6-14.184-24.941-18.489-32.541l-.072.118h.144l-.066-.118A23.831,23.831,0,0,1,42.08,221.4c-.151-1.044-.19-1.857-.23-2.4v-.617A.569.569,0,0,0,41.818,218.171Z",
    transform: "translate(265.049 -110.341)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14771",
    "data-name": "Path 14771",
    d: "M54.34,222.41a1.313,1.313,0,0,0,0-.23,3.181,3.181,0,0,1,.053-.656v-.5a4.515,4.515,0,0,1,.092-.6,11.158,11.158,0,0,1,.3-1.477,13.822,13.822,0,0,1,1.588-3.8,14.229,14.229,0,0,1,17.065-6.111,14.859,14.859,0,0,1,1.857.807,15.385,15.385,0,0,1,1.746,1.116,16.684,16.684,0,0,1,1.615,1.372,16.017,16.017,0,0,1,1.4,1.641,13.967,13.967,0,0,1,2.041,3.938,14.118,14.118,0,0,1,0,8.972,13.534,13.534,0,0,1-2.022,3.938,16.065,16.065,0,0,1-1.385,1.654,17.52,17.52,0,0,1-1.608,1.378,15.446,15.446,0,0,1-1.746,1.122,14.439,14.439,0,0,1-1.733.774,14.275,14.275,0,0,1-17.117-6.025,13.435,13.435,0,0,1-1.608-3.794,10.285,10.285,0,0,1-.308-1.477,3.909,3.909,0,0,0-.1-.6v-.505a5.863,5.863,0,0,0-.053-.656,1.312,1.312,0,0,0,0-.236,1.069,1.069,0,0,0,0,.236c0,.171,0,.394,0,.656v.505a5.665,5.665,0,0,0,.079.6,11.264,11.264,0,0,0,.282,1.5,13.632,13.632,0,0,0,1.575,3.853,14.439,14.439,0,0,0,17.367,6.2,13.455,13.455,0,0,0,3.669-1.969,15.8,15.8,0,0,0,1.647-1.4,16.055,16.055,0,0,0,1.378-1.693,14.059,14.059,0,0,0,2.074-4,15.706,15.706,0,0,0,.735-4.594,15.51,15.51,0,0,0-.761-4.594,14.02,14.02,0,0,0-2.087-3.991,16.8,16.8,0,0,0-1.431-1.68,17.348,17.348,0,0,0-1.654-1.391,16.044,16.044,0,0,0-1.785-1.135,15.04,15.04,0,0,0-1.9-.788,14.439,14.439,0,0,0-17.334,6.288,13.894,13.894,0,0,0-1.556,3.866,10.042,10.042,0,0,0-.269,1.49c0,.223-.066.42-.079.61s0,.348,0,.5v.689a1.234,1.234,0,0,0-.026.2Z",
    transform: "translate(260.77 -114.869)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14772",
    "data-name": "Path 14772",
    d: "M72.613,232.879l8.355-5.822-2.035-2.914-5.6,3.905-7.246-9.208-2.789,2.2Z",
    transform: "translate(257.146 -118.623)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14773",
    "data-name": "Path 14773",
    d: "M405.537,72.53a27.678,27.678,0,0,0-7.108,1.871l-5.218-4.371-8.966,6.826,2.822,6.2a27.9,27.9,0,0,0-3.7,6.347l-6.78.6-1.516,11.158,6.38,2.383a27.382,27.382,0,0,0,1.877,7.148l-4.378,5.251,6.826,8.972,6.2-2.829a27.664,27.664,0,0,0,6.347,3.7l.6,6.78,11.158,1.516,2.382-6.38a27.631,27.631,0,0,0,7.115-1.917l5.251,4.371,8.966-6.826-2.829-6.2a27.528,27.528,0,0,0,3.7-6.347l6.78-.6,1.516-11.158-6.373-2.389a27.709,27.709,0,0,0-1.877-7.1l4.358-5.244-6.819-8.972-6.2,2.829a27.764,27.764,0,0,0-6.347-3.7l-.6-6.78L407.939,66.15l-2.383,6.38Zm3.334,15.4a12.09,12.09,0,1,1-12.142,9.248A12.09,12.09,0,0,1,408.872,87.927Z",
    transform: "translate(-309.419 -66.15)",
    fill: "#f5f5f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14774",
    "data-name": "Path 14774",
    d: "M259.986,128.109a17.939,17.939,0,0,0-4.594,1.221L252,126.488l-5.822,4.43,1.831,4.023a18.023,18.023,0,0,0-2.4,4.122l-4.4.387-.978,7.22,4.135,1.549a18.062,18.062,0,0,0,1.221,4.594l-2.842,3.387,4.417,5.868,4.023-1.831a17.86,17.86,0,0,0,4.122,2.4l.387,4.4,7.22.984,1.549-4.141a17.787,17.787,0,0,0,4.594-1.214l3.387,2.842,5.822-4.43-1.838-4.023a17.788,17.788,0,0,0,2.4-4.122l4.4-.387.984-7.253-4.141-1.542a17.905,17.905,0,0,0-1.214-4.594l2.881-3.406-4.43-5.822-4.023,1.831a18.075,18.075,0,0,0-4.115-2.4l-.387-4.4L261.535,124l-1.549,4.135Zm2.179,10a7.876,7.876,0,1,1-7.876,6.006,7.876,7.876,0,0,1,7.876-6.006Z",
    transform: "translate(-62.202 -86.031)",
    fill: "#ebebeb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14775",
    "data-name": "Path 14775",
    d: "M347.531,210.077a9.563,9.563,0,0,0-2.625,1.733,12.641,12.641,0,0,0-4.056,7.456,12.811,12.811,0,0,0,.446,5.946,13.022,13.022,0,0,0,3.748,5.736A12.116,12.116,0,0,0,348.174,233a12.241,12.241,0,0,0,3.748,1.1,12.93,12.93,0,0,0,13.514-7.41,12.134,12.134,0,0,0,1.1-3.748,12.345,12.345,0,0,0-.046-3.748,13.068,13.068,0,0,0-2.822-6.242,12.786,12.786,0,0,0-4.778-3.57,12.641,12.641,0,0,0-8.486-.591,9.642,9.642,0,0,0-2.868,1.313c.039.079,1-.518,2.94-1a12.641,12.641,0,0,1,8.2.781,12.286,12.286,0,0,1,4.489,3.485,12.387,12.387,0,0,1,1.595,13.048,12.28,12.28,0,0,1-12.753,6.99,11.545,11.545,0,0,1-3.551-1.024,11.328,11.328,0,0,1-2.98-1.923,12.4,12.4,0,0,1-4.135-11.1,12.674,12.674,0,0,1,3.761-7.305A28.359,28.359,0,0,1,347.531,210.077Z",
    transform: "translate(-210.559 -115.006)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14776",
    "data-name": "Path 14776",
    d: "M320.776,187.774a3.826,3.826,0,0,0-.1-.433c-.085-.322-.2-.755-.341-1.313l-1.418-5.152-.053.131,10.4-5.625-.223-.039,4.706,5.369.085.1.125-.033a29.133,29.133,0,0,1,7.607-.807h.144l.072-.125c1.083-1.969,2.258-4.05,3.485-6.242l-.3.125,11.342,3.334-.2-.3c-.144,2.212-.3,4.64-.453,7.134v.184l.158.092a28.6,28.6,0,0,1,5.907,4.778l.131.138.184-.053,6.872-1.969-.374-.151,5.7,10.423.072-.42-5.349,4.732-.158.138.046.2a28.486,28.486,0,0,1,.794,7.535v.21l.19.105,6.248,3.472-.171-.413-3.308,11.348.368-.256-7.128-.44h-.223l-.112.19a28.667,28.667,0,0,1-4.758,5.907h0c-.046.164.092-.361-.105.368h0v.2l.066.217.125.427.243.866.5,1.72q.492,1.723.978,3.426l.177-.42-10.364,5.69.44.072-4.732-5.343-.092-.157-.21.053a28.819,28.819,0,0,1-7.568.834h-.217l-.1.184q-1.766,3.17-3.465,6.255l.4-.164L325.469,240.6l.236.341c.144-2.415.289-4.8.427-7.128v-.2l-.171-.1a28.656,28.656,0,0,1-5.953-4.758l-.131-.138-.184.053-6.859,1.969.348.144-5.71-10.35-.059.341,5.336-4.745.118-.105-.033-.151a28.6,28.6,0,0,1-.853-7.594v-.144l-.125-.072-6.255-3.446.1.249c1.26-4.4,2.337-8.152,3.282-11.361l-.171.112,7.134.394h.072l.039-.059a29.289,29.289,0,0,1,3.426-4.667l.971-1.05a3.427,3.427,0,0,0,.322-.354,3.283,3.283,0,0,0-.361.308c-.236.217-.584.545-1.024,1.011a28.042,28.042,0,0,0-3.538,4.634l.105-.059-7.128-.479h-.125l-.039.131c-.952,3.2-2.061,6.944-3.36,11.335l-.046.164.151.079,6.235,3.492-.125-.217a29.239,29.239,0,0,0,.82,7.732l.085-.263-5.362,4.726-.171.144.112.2,5.664,10.377.118.21.23-.066,6.872-1.969-.315-.085a29.147,29.147,0,0,0,6.071,4.883l-.158-.3q-.217,3.5-.446,7.128v.269l.256.072,11.342,3.321.269.079.131-.243,3.472-6.248-.315.184a29.416,29.416,0,0,0,7.758-.84l-.354-.112,4.732,5.349.19.217.249-.138,10.37-5.684.256-.138-.085-.282q-.486-1.7-.978-3.42l-.492-1.726-.249-.86-.125-.433-.059-.217-.033-.105v-.1h0c-.2.729-.052.2-.1.361h0a29.332,29.332,0,0,0,4.877-6.084l-.335.177,7.134.433h.289l.079-.276,3.282-11.348.079-.276-.249-.138-6.248-3.459.177.315a29.227,29.227,0,0,0-.847-7.751l-.112.341c1.857-1.647,3.682-3.282,5.349-4.739l.2-.184-.125-.236-5.7-10.357L369,186.4l-.249.072-6.859,1.969.315.085a29.725,29.725,0,0,0-6.084-4.863l.144.276c.144-2.488.289-4.923.42-7.128v-.23l-.223-.066-11.355-3.282-.2-.059-.1.184c-1.214,2.192-2.376,4.306-3.452,6.255l.217-.118a29.017,29.017,0,0,0-7.719.866l.21.066-4.752-5.329-.1-.112-.131.072L318.754,180.8l-.085.046v.092c.656,2.2,1.168,3.9,1.523,5.074l.4,1.313A2.662,2.662,0,0,0,320.776,187.774Z",
    transform: "translate(-197.337 -102.928)",
    fill: "#ebebeb"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    transform: "translate(9.32 34.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14778",
    "data-name": "Path 14778",
    d: "M559.627,370.515l-5.323,12.07s10.5,9.464,9.714,11.814l-23.773-9.484,7.522-19.145Z",
    transform: "translate(-496.868 -185.711)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14779",
    "data-name": "Path 14779",
    d: "M559.627,370.515l-5.323,12.07s10.5,9.464,9.714,11.814l-23.773-9.484,7.522-19.145Z",
    transform: "translate(-496.868 -185.711)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14780",
    "data-name": "Path 14780",
    d: "M540.131,393.923l.834-1.923,22.486,9.845s.873.879.459,1.582Z",
    transform: "translate(-496.753 -194.725)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14781",
    "data-name": "Path 14781",
    d: "M629.058,395.884l-6.668,11.388s9.333,10.593,8.309,12.851L608.16,407.994l9.655-18.194Z",
    transform: "translate(-608.16 -193.969)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14782",
    "data-name": "Path 14782",
    d: "M629.058,395.884l-6.668,11.388s9.333,10.593,8.309,12.851L608.16,407.994l9.655-18.194Z",
    transform: "translate(-608.16 -193.969)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14783",
    "data-name": "Path 14783",
    d: "M608.029,416.532l1.063-1.792,21.2,12.3s.768.978.276,1.621Z",
    transform: "translate(-608.029 -202.539)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14784",
    "data-name": "Path 14784",
    d: "M530.5,137.473l14.61,1.142.486-8.178s5.907-.085,6.773-5.841,1.746-19.132,1.746-19.132h0a20.235,20.235,0,0,0-20.491-.3l-.945.538Z",
    transform: "translate(-480.526 -95.2)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14785",
    "data-name": "Path 14785",
    d: "M550.67,143.25a13.553,13.553,0,0,1-7.22-3.19s1.273,4.529,7.1,4.818Z",
    transform: "translate(-485.58 -108.098)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14786",
    "data-name": "Path 14786",
    d: "M567.618,116.4c-.092-.059-3.8-1.733-4.227,2.232s3.636,3.571,3.656,3.459S567.618,116.4,567.618,116.4Z",
    transform: "translate(-515.597 -99.83)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14787",
    "data-name": "Path 14787",
    d: "M567.522,121.106a1.626,1.626,0,0,1-.2.085.689.689,0,0,1-.512-.046,1.72,1.72,0,0,1-.656-1.621,2.251,2.251,0,0,1,.3-.965.807.807,0,0,1,.578-.473.354.354,0,0,1,.387.236.286.286,0,0,1,0,.2c0,.007.092-.053.079-.223a.434.434,0,0,0-.131-.263.492.492,0,0,0-.368-.144.984.984,0,0,0-.788.538,2.356,2.356,0,0,0-.361,1.076,1.805,1.805,0,0,0,.827,1.818.728.728,0,0,0,.656-.033C567.509,121.2,567.535,121.119,567.522,121.106Z",
    transform: "translate(-517.122 -100.479)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14788",
    "data-name": "Path 14788",
    d: "M535.943,120.344a.833.833,0,0,1-.912.715.788.788,0,0,1-.742-.86.827.827,0,0,1,.906-.722.8.8,0,0,1,.748.866Z",
    transform: "translate(-464.842 -101.023)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14789",
    "data-name": "Path 14789",
    d: "M537.134,118.537c-.118.092-.656-.459-1.562-.578s-1.6.23-1.68.105.092-.236.4-.4a2.317,2.317,0,0,1,1.365-.217,2.218,2.218,0,0,1,1.227.591C537.128,118.287,537.187,118.5,537.134,118.537Z",
    transform: "translate(-465.777 -100.319)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14790",
    "data-name": "Path 14790",
    d: "M549.073,118.824a.833.833,0,0,1-.912.715.794.794,0,0,1-.742-.86.833.833,0,0,1,.906-.722.8.8,0,0,1,.748.866Z",
    transform: "translate(-486.589 -100.501)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14791",
    "data-name": "Path 14791",
    d: "M550.443,116.917c-.118.1-.656-.453-1.562-.578s-1.595.23-1.68.112.092-.236.407-.4a2.245,2.245,0,0,1,1.359-.223,2.2,2.2,0,0,1,1.227.6C550.436,116.674,550.5,116.877,550.443,116.917Z",
    transform: "translate(-487.821 -99.762)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14792",
    "data-name": "Path 14792",
    d: "M540.127,124.324a6.367,6.367,0,0,1,1.477-.053c.23,0,.453,0,.512-.158a1.141,1.141,0,0,0-.059-.656c-.131-.578-.276-1.188-.427-1.818a29.709,29.709,0,0,1-.866-4.719,30.024,30.024,0,0,1,1.247,4.634l.394,1.825a1.312,1.312,0,0,1,0,.906.564.564,0,0,1-.42.276,1.268,1.268,0,0,1-.387,0A5.861,5.861,0,0,1,540.127,124.324Z",
    transform: "translate(-475.215 -100.146)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14793",
    "data-name": "Path 14793",
    d: "M544.244,128.58c.144,0,0,.971.742,1.772s1.766.834,1.752.971-.256.158-.689.105a2.415,2.415,0,0,1-1.47-.755,2.087,2.087,0,0,1-.558-1.477C544.04,128.79,544.178,128.567,544.244,128.58Z",
    transform: "translate(-482.023 -104.153)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14794",
    "data-name": "Path 14794",
    d: "M550.19,111.781c-.125.23-.991,0-2.048,0s-1.969.144-2.048-.092c-.046-.112.131-.322.505-.505a3.393,3.393,0,0,1,1.569-.315,3.485,3.485,0,0,1,1.549.407C550.071,111.459,550.262,111.676,550.19,111.781Z",
    transform: "translate(-486.846 -98.066)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14795",
    "data-name": "Path 14795",
    d: "M536.789,114.534c-.184.177-.768-.112-1.5-.23s-1.378-.053-1.49-.282c-.046-.112.079-.3.374-.453a2.12,2.12,0,0,1,1.267-.158,2.061,2.061,0,0,1,1.142.571C536.815,114.226,536.874,114.442,536.789,114.534Z",
    transform: "translate(-465.399 -98.928)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14796",
    "data-name": "Path 14796",
    d: "M551.869,98.377a2.179,2.179,0,0,0-.518-2.015,1.529,1.529,0,0,0-1.969-.125,1.785,1.785,0,0,0-1.214-2.35c-.932-.19-1.838.407-2.783.525a4.305,4.305,0,0,1-2.625-.689c-.807-.459-1.536-1.05-2.356-1.483a7.443,7.443,0,0,0-10.035,3,3.282,3.282,0,0,0-3.656.827,5.428,5.428,0,0,0-1.359,3.669,12.3,12.3,0,0,0,.295,2.676.539.539,0,0,1-.032.225c-.387,3.177-.551,6.951.794,7.161,2.356.368,2.415-4.155,2.415-4.155,3.052-.709,2.586-5.2,3.4-5.75s2.547-1.871,8.165,2.074a11.86,11.86,0,0,0,7.075,1.792h.249a5.526,5.526,0,0,0,1.641-.44,3.111,3.111,0,0,0,1.483-1.247,1.7,1.7,0,0,0-.079-1.851A3.748,3.748,0,0,0,551.869,98.377Z",
    transform: "translate(-474.959 -91.363)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14797",
    "data-name": "Path 14797",
    d: "M558.342,147.126l-.65,22.893L543.45,139.362l.354-2.842Z",
    transform: "translate(-493.253 -106.882)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14798",
    "data-name": "Path 14798",
    d: "M523.476,256.61c.518.171,30.192,30.159,29.535,35.547s-21.771,45.288-21.771,45.288l-15.1-7.423,14.131-34.97-.184-2.172-17.268-14.144L513.749,256Z",
    transform: "translate(-467.832 -147.976)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14799",
    "data-name": "Path 14799",
    d: "M611.752,260.026c-.348.519-5.48,47.631-6.859,50.066s-22,42.662-22,42.662l-15.312-6.17,18.693-44.2-2.127-41.835,1.149-11.814,23.123,4.772Z",
    transform: "translate(-562.5 -145.489)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14800",
    "data-name": "Path 14800",
    d: "M567.614,316.477a2.3,2.3,0,0,0,.1-.473c.059-.341.131-.794.223-1.359.184-1.221.446-2.921.761-5.008.61-4.273,1.451-10.108,2.383-16.553s1.693-12.3,2.284-16.566c.269-2.1.492-3.807.656-5.028l.158-1.372a2.363,2.363,0,0,0,0-.479s-.039.164-.1.473-.131.794-.223,1.359l-.755,5.014c-.617,4.266-1.457,10.1-2.383,16.553s-1.7,12.293-2.284,16.566c-.276,2.094-.5,3.8-.656,5.021-.066.571-.125,1.03-.164,1.372A2.394,2.394,0,0,0,567.614,316.477Z",
    transform: "translate(-524.951 -152.659)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14801",
    "data-name": "Path 14801",
    d: "M602.61,328.41a23.178,23.178,0,0,0,.893,3.735,22.529,22.529,0,0,0,1.208,3.643,22.97,22.97,0,0,0-.912-3.708A21.79,21.79,0,0,0,602.61,328.41Z",
    transform: "translate(-578.45 -172.858)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14802",
    "data-name": "Path 14802",
    d: "M605.815,339.824a4.307,4.307,0,0,0,.84-1.162,11.506,11.506,0,0,0,1.424-6.695,4.222,4.222,0,0,0-.289-1.4,14.966,14.966,0,0,1-1.969,9.254Z",
    transform: "translate(-583.972 -173.601)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14803",
    "data-name": "Path 14803",
    d: "M544.229,307.75A8.047,8.047,0,0,0,540,311.609c.079.052.814-1.017,1.969-2.074S544.3,307.835,544.229,307.75Z",
    transform: "translate(-476.875 -165.755)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14804",
    "data-name": "Path 14804",
    d: "M545.791,305.63a6.609,6.609,0,0,0-2.291,3.7,53.243,53.243,0,0,1,2.291-3.7Z",
    transform: "translate(-480.734 -165.026)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14805",
    "data-name": "Path 14805",
    d: "M595.107,179.466l-3.787,18.811-3.085,26.254s-12.72-1.779-18.141-3.492c-6.288-1.969-19.966-3.689-19.966-3.689l2.31,2.284c-4.9-1.372-8.014-6.038-8.014-6.038,8.427-7.817,15.647-23.937,15.647-23.937l6.412-31.846s.971-4.489,1.562-6.491,10.324-8.441,11.676-9.254l.847-.4.269-2.553,1-.6,10.528,9.576a11.387,11.387,0,0,1,3.669,7.154,82.04,82.04,0,0,1,.459,11.978C596.374,170.992,595.107,179.466,595.107,179.466Z",
    transform: "translate(-532.098 -107.566)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14806",
    "data-name": "Path 14806",
    d: "M532.628,151.08s5.566,2.986,6.531,5.52-1.9,30.31-1.9,30.31l20,.381.079,11.913s-31.76,2.514-33,.794c-1.667-2.323-3.61-24.029-3.61-24.029L520,160.348S521.818,148.442,532.628,151.08Z",
    transform: "translate(-476.852 -111.764)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5128",
    "data-name": "Group 5128",
    transform: "translate(42.957 67.953)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14807",
    "data-name": "Path 14807",
    d: "M568.045,217.662a19.2,19.2,0,0,1-8.007.742c-2.816-.256-5.684-1.8-6.747-4.424-.814-2-.473-4.266-.6-6.426-.112-1.884-.571-3.721-.86-5.579s.656-5.251,1.313-7.056c0,0,.709,12.891,2.73,18.305a4.346,4.346,0,0,0,1.234,1.969,4.6,4.6,0,0,0,2.625.722,75.084,75.084,0,0,0,8.71-.177",
    transform: "translate(-551.78 -194.92)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14808",
    "data-name": "Path 14808",
    d: "M519.846,168a1.63,1.63,0,0,0,0,.289c0,.2,0,.473.033.827,0,.748.085,1.818.151,3.19s.164,3.085.269,5.047.184,4.214.427,6.682.473,5.172.781,8.073.656,6,1.214,9.235a19.584,19.584,0,0,0,.551,2.448,4.8,4.8,0,0,0,1.444,2.166,3.656,3.656,0,0,0,2.487.886h2.625c3.57-.092,7.259-.269,11.04-.479,5.677-.308,11.158-.656,16.258-1.024h.144v-.144c0-4.233-.046-8.217-.072-11.9v-.138h-.138l-19.3-.414-5.4-.092h-1.91s.164,0,.486.033l1.418.059,5.4.171,19.3.532-.138-.138c0,3.676,0,7.66.039,11.893l.151-.158c-5.113.348-10.587.7-16.258,1.011-3.774.2-7.463.394-11.027.486-.893,0-1.772.033-2.625,0a3.321,3.321,0,0,1-2.3-.807,4.456,4.456,0,0,1-1.346-2.022,19.869,19.869,0,0,1-.545-2.4c-.558-3.223-.912-6.321-1.247-9.189s-.591-5.592-.82-8.06-.341-4.713-.472-6.675-.236-3.649-.322-5.041-.164-2.442-.217-3.183a6.78,6.78,0,0,0-.066-.834A1.4,1.4,0,0,0,519.846,168Z",
    transform: "translate(-476.685 -117.712)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14809",
    "data-name": "Path 14809",
    d: "M525.972,218.282a50.961,50.961,0,0,0,.138-5.776,51.09,51.09,0,0,0-.2-5.776,50.975,50.975,0,0,0-.138,5.776A51.09,51.09,0,0,0,525.972,218.282Z",
    transform: "translate(-449.43 -131.026)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14810",
    "data-name": "Path 14810",
    d: "M523.007,209.408c.039,0-.158-.249-.538-.118a.61.61,0,0,0-.407.525.7.7,0,0,0,1.208.564.656.656,0,0,0,.2-.624c-.092-.381-.354-.459-.361-.42a1.214,1.214,0,0,1,.131.446.479.479,0,0,1-.164.374.459.459,0,0,1-.466.072.446.446,0,0,1-.243-.394.394.394,0,0,1,.2-.335C522.8,209.362,522.987,209.448,523.007,209.408Z",
    transform: "translate(-444.351 -131.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14811",
    "data-name": "Path 14811",
    d: "M602.62,172.08s-10.41,13.606-11.676,17.308-.289,9.031,1.831,11.578,3.826,1.51,3.826,1.51Z",
    transform: "translate(-568.333 -119.114)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14812",
    "data-name": "Path 14812",
    d: "M590.94,216.729a11.462,11.462,0,0,0,2.625.61,10.868,10.868,0,0,0,2.665.289,11.342,11.342,0,0,0-2.625-.61A10.868,10.868,0,0,0,590.94,216.729Z",
    transform: "translate(-562.31 -134.462)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14813",
    "data-name": "Path 14813",
    d: "M610.848,232a3.9,3.9,0,0,0-.282.715c-.157.473-.394,1.142-.7,1.969a59.094,59.094,0,0,1-2.8,6.307,67.3,67.3,0,0,1-3.492,5.946c-.486.742-.886,1.313-1.168,1.739a3.35,3.35,0,0,0-.407.656,3.439,3.439,0,0,0,.512-.578c.308-.387.742-.958,1.254-1.687a51.231,51.231,0,0,0,3.6-5.907,46.056,46.056,0,0,0,2.717-6.38c.282-.84.492-1.529.61-2.008A3,3,0,0,0,610.848,232Z",
    transform: "translate(-584.187 -139.714)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5129",
    "data-name": "Group 5129",
    transform: "translate(16.849 93.9)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14814",
    "data-name": "Path 14814",
    d: "M612.19,234.46c-1.654,2.94-3.347,5.907-5.854,8.185a14.989,14.989,0,0,0-2.56,2.474,3.15,3.15,0,0,0-.322,3.347,1.037,1.037,0,0,0,1.037.558,1.313,1.313,0,0,0,.656-.551,40.523,40.523,0,0,0,6.911-13.56",
    transform: "translate(-603.1 -234.46)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5130",
    "data-name": "Group 5130",
    transform: "translate(25.558 55.046)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14815",
    "data-name": "Path 14815",
    d: "M593.479,203.512a5.034,5.034,0,0,1-1.713-4.713,17.436,17.436,0,0,1,1.726-4.942,80.956,80.956,0,0,0,5.06-14.833l1.017-3.774-5.146,26.91Z",
    transform: "translate(-591.72 -175.25)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14816",
    "data-name": "Path 14816",
    d: "M565.708,147.4a21.41,21.41,0,0,0-1.969-1.936,22.624,22.624,0,0,0-1.969-1.969,7.981,7.981,0,0,0,1.707,2.172,7.672,7.672,0,0,0,2.232,1.733Z",
    transform: "translate(-512.643 -109.277)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14817",
    "data-name": "Path 14817",
    d: "M548.44,153c0,.059.6.243,1.523.7a12.076,12.076,0,0,1,5.52,5.592c.446.925.656,1.542.656,1.529a1.354,1.354,0,0,0-.072-.453,8.132,8.132,0,0,0-.394-1.175,10.882,10.882,0,0,0-5.638-5.7,7.913,7.913,0,0,0-1.168-.407A1.313,1.313,0,0,0,548.44,153Z",
    transform: "translate(-494.325 -112.554)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14818",
    "data-name": "Path 14818",
    d: "M590.688,205.3a1.158,1.158,0,0,0,.164-.263l.414-.781c.374-.729.879-1.72,1.5-2.927h0c.656-2.98,1.569-7.325,2.573-12.162.932-4.588,1.739-8.716,2.4-11.722l.656-3.564c.066-.387.125-.709.171-.971a1.2,1.2,0,0,0,.033-.341,1.655,1.655,0,0,0-.1.328c-.059.256-.138.578-.23.965-.2.88-.466,2.074-.788,3.538-.656,3.032-1.51,7.154-2.468,11.7-1,4.837-1.884,9.189-2.468,12.188h0c-.584,1.227-1.057,2.232-1.4,2.973l-.368.807A1.251,1.251,0,0,0,590.688,205.3Z",
    transform: "translate(-564.513 -119.283)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14819",
    "data-name": "Path 14819",
    d: "M546.65,192.646a5.237,5.237,0,0,0,.158-.984c.072-.7.171-1.608.289-2.7.236-2.277.538-5.434.847-8.913s.571-6.642.748-8.933c.079-1.1.138-2.008.19-2.7a5.491,5.491,0,0,0,0-1,6.7,6.7,0,0,0-.151.985c-.072.7-.171,1.608-.3,2.7-.23,2.278-.532,5.428-.84,8.913s-.571,6.642-.748,8.926c-.079,1.1-.138,2.008-.19,2.711A7.17,7.17,0,0,0,546.65,192.646Z",
    transform: "translate(-485.906 -117.509)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14820",
    "data-name": "Path 14820",
    d: "M497.845,206.708s4.319-3.282,5.369-3.472c.807-.151,5.618-.066,7.83,0a1.575,1.575,0,0,1,1.588,1.536.663.663,0,0,1,0,.158,1.425,1.425,0,0,1-1.05,1.09,1.673,1.673,0,0,1,1.162,1.582c0,1.247-1.49,1.51-1.49,1.51l.217.2a1.49,1.49,0,0,1-.735,2.5l-.656.158a1.47,1.47,0,0,1,.912,1.241c0,1.641-3.728,1.969-3.728,1.969s-9.143,1.451-9.34,1.385S497.845,206.708,497.845,206.708Z",
    transform: "translate(-417.699 -129.796)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14821",
    "data-name": "Path 14821",
    d: "M507.875,199.868a2.665,2.665,0,0,1-1.09,2.218l-5.1-.2s3.794-1.313,4.338-1.969a3.972,3.972,0,0,1,.729-.715.722.722,0,0,1,1.122.663Z",
    transform: "translate(-415.377 -128.396)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14822",
    "data-name": "Path 14822",
    d: "M500.38,203.181a7.219,7.219,0,0,0,2.323.164,9.01,9.01,0,0,0,2.323-.164,7.811,7.811,0,0,0-2.33-.164A9.627,9.627,0,0,0,500.38,203.181Z",
    transform: "translate(-411.669 -129.74)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14823",
    "data-name": "Path 14823",
    d: "M499.66,207.516a4.824,4.824,0,0,0,2.008.2,4.745,4.745,0,0,0,1.969-.348,9.279,9.279,0,0,0-2,0A8.8,8.8,0,0,0,499.66,207.516Z",
    transform: "translate(-409.807 -131.227)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14824",
    "data-name": "Path 14824",
    d: "M508.328,207.056c-.079.053,0,.328.308.512s.584.164.591.072-.184-.2-.407-.348S508.407,207.017,508.328,207.056Z",
    transform: "translate(-421.068 -131.135)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14825",
    "data-name": "Path 14825",
    d: "M499.9,212.391a14.7,14.7,0,0,0,4.378-.144,7.286,7.286,0,0,0-2.2-.1,7.4,7.4,0,0,0-2.179.243Z",
    transform: "translate(-410.605 -132.874)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14826",
    "data-name": "Path 14826",
    d: "M509.53,210.46c-.039,0-.118.092-.144.289a1.037,1.037,0,0,0,.893,1.135c.2,0,.315,0,.315-.072s-.44-.144-.729-.519S509.609,210.48,509.53,210.46Z",
    transform: "translate(-423.143 -132.308)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14827",
    "data-name": "Path 14827",
    d: "M501.75,217.072a6.111,6.111,0,0,0,1.969-.079,5.986,5.986,0,0,0,1.969-.407,6.11,6.11,0,0,0-1.969.079,6.19,6.19,0,0,0-1.969.407Z",
    transform: "translate(-413.229 -134.398)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14828",
    "data-name": "Path 14828",
    d: "M510.632,214.9c-.039,0-.105.105-.1.308a1.24,1.24,0,0,0,.276.656c.368.453.788.617.834.551s-.269-.374-.578-.755A5,5,0,0,1,510.632,214.9Z",
    transform: "translate(-424.953 -133.834)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14829",
    "data-name": "Path 14829",
    d: "M612.785,260.691a5.809,5.809,0,0,1-4.417-2.783c-.1-.177-.2-.42-.059-.571a.525.525,0,0,1,.387-.118,11.986,11.986,0,0,1,4.187.722.571.571,0,0,1,.374.282.558.558,0,0,1,0,.341c-.177.689-.354,1.378-.538,2.074",
    transform: "translate(-590.719 -148.382)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5131",
    "data-name": "Group 5131",
    transform: "translate(17.52 108.834)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14830",
    "data-name": "Path 14830",
    d: "M612.785,260.691a5.809,5.809,0,0,1-4.417-2.783c-.1-.177-.2-.42-.059-.571a.525.525,0,0,1,.387-.118,11.986,11.986,0,0,1,4.187.722.571.571,0,0,1,.374.282.558.558,0,0,1,0,.341c-.177.689-.354,1.378-.538,2.074",
    transform: "translate(-608.239 -257.216)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14831",
    "data-name": "Path 14831",
    d: "M541.285,152.68s2.1,7.043,1.523,6.642-1.831-1.51-1.831-1.51Z",
    transform: "translate(-476.196 -112.444)",
    fill: "#ebebeb"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flag--inject-2",
    transform: "translate(282.576 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14835",
    "data-name": "Path 14835",
    d: "M135.51,70.245c6.655,1.03,11.532-4.594,13.087-9.537,1.437-4.594,2.12-9.379,4.135-13.783,2.822-6.1,10.291-8.926,16.993-8.362s13.462,3.938,19.395,7.1l-1.641,36.755s-12.91-13.783-19.119-14.006c-10.357-.413-9.793,16.605-19.848,19.119,0,0-14.1,3.82-23.628-8.486a34.558,34.558,0,0,1-6.563-17.308S122.954,68.308,135.51,70.245Z",
    transform: "translate(-118.32 -38.492)",
    fill: "#962cc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14836",
    "data-name": "Path 14836",
    d: "M125.636,40.17c-.092,0-1.9,39.039-4.043,87.195s-3.807,87.208-3.715,87.215,1.9-39.033,4.043-87.2S125.728,40.177,125.636,40.17Z",
    transform: "translate(-54.548 -39.069)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5132",
    "data-name": "Group 5132",
    transform: "translate(19.388 19.669)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14837",
    "data-name": "Path 14837",
    d: "M188.179,68.46a44.907,44.907,0,0,1-4.9,11.04,13.591,13.591,0,0,1-8.309,6.255,8.191,8.191,0,0,0-1.864.479A1.8,1.8,0,0,0,172,87.7c0,.965.965,1.595,1.831,2.022a15.227,15.227,0,0,0,3.826,1.47c1.313.249,2.4.394,3.328-.656a18.719,18.719,0,0,0,2.4-2.881c3.039-5.179,4.542-12.582,4.791-18.437",
    transform: "translate(-172 -68.46)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14838",
    "data-name": "Path 14838",
    d: "M171.078,88.058a2.284,2.284,0,0,0,.3-.171,8.772,8.772,0,0,0,.794-.584,13.441,13.441,0,0,0,2.455-2.665,20.346,20.346,0,0,0,2.461-4.778A53.01,53.01,0,0,0,178.9,73.54a70.086,70.086,0,0,0,1.7-11.814c.085-1.523.1-2.757.1-3.61v-.985a1.745,1.745,0,0,0,0-.341,1.188,1.188,0,0,0-.039.341,9.279,9.279,0,0,1-.039.978c-.039.853-.085,2.087-.2,3.6a78.709,78.709,0,0,1-1.785,11.749,56.546,56.546,0,0,1-1.812,6.294,21.212,21.212,0,0,1-2.389,4.739,14.525,14.525,0,0,1-2.343,2.7C171.452,87.776,171.058,88.038,171.078,88.058Z",
    transform: "translate(-144.536 -44.781)",
    fill: "#263238"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stairs--inject-2",
    transform: "translate(0 172.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14839",
    "data-name": "Path 14839",
    d: "M144.67,317.72,56.74,332.114V317.72Z",
    transform: "translate(249.123 -306.943)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14840",
    "data-name": "Path 14840",
    d: "M300.756,367.27,212.82,381.664V367.27Z",
    transform: "translate(-9.384 -323.971)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14841",
    "data-name": "Path 14841",
    d: "M455.766,414.66,367.83,429.054V414.66Z",
    transform: "translate(-266.112 -340.257)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14842",
    "data-name": "Path 14842",
    d: "M610.57,452.38l-87.93,14.394V452.38Z",
    transform: "translate(-522.502 -353.22)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4743",
    "data-name": "Rectangle 4743",
    width: 87.93,
    height: 10.784,
    transform: "translate(305.863)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5133",
    "data-name": "Group 5133",
    transform: "translate(305.874)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4744",
    "data-name": "Rectangle 4744",
    width: 27.442,
    height: 10.784,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4745",
    "data-name": "Rectangle 4745",
    width: 87.93,
    height: 10.784,
    transform: "translate(203.443 32.515)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5134",
    "data-name": "Group 5134",
    transform: "translate(203.443 32.515)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4746",
    "data-name": "Rectangle 4746",
    width: 27.442,
    height: 10.784,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4747",
    "data-name": "Rectangle 4747",
    width: 87.93,
    height: 10.784,
    transform: "translate(101.718 63.619)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5135",
    "data-name": "Group 5135",
    transform: "translate(101.722 63.619)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4748",
    "data-name": "Rectangle 4748",
    width: 27.442,
    height: 10.784,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4749",
    "data-name": "Rectangle 4749",
    width: 87.93,
    height: 10.784,
    transform: "translate(0 88.376)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5136",
    "data-name": "Group 5136",
    transform: "translate(0 88.376)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4750",
    "data-name": "Rectangle 4750",
    width: 27.442,
    height: 10.784,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14843",
    "data-name": "Path 14843",
    d: "M579.038,374.906a2.389,2.389,0,1,1-.7-1.694A2.389,2.389,0,0,1,579.038,374.906Z",
    transform: "translate(-524.851 -325.772)",
    fill: "#ebebeb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar);
export default __webpack_public_path__ + "static/media/char.868b10ffdbc7a354e3d384c0aefa3638.svg";
export { ForwardRef as ReactComponent };